{
  "commons": {
    "languages": {
      "en": "English",
      "sv": "Swedish",
      "BG": "Bulgarian",
      "CS": "Czech",
      "DA": "Danish",
      "DE": "German",
      "EL": "Greek",
      "en-GB": "English (GB)",
      "en-US": "English (US)",
      "ES": "Spanish",
      "ET": "Estonian",
      "FI": "Finnish",
      "FR": "French",
      "HU": "Hungarian",
      "ID": "Indonesian",
      "IT": "Italian",
      "JA": "Japanese",
      "KO": "Korean",
      "LT": "Lithuanian",
      "LV": "Latvian",
      "NB": "Norwegian (Bokmål)",
      "NL": "Dutch",
      "PL": "Polish",
      "PT": "Portuguese",
      "RO": "Romanian",
      "RU": "Russian",
      "SK": "Slovak",
      "SL": "Slovenian",
      "SV": "Swedish",
      "TR": "Turkish",
      "UK": "Ukrainian",
      "ZH": "Chinese",
      "AUTO_DETECT": "Auto detect"
    },
    "all": "All",
    "nothing": "Nothing here at the moment",
    "somethingWentWrong": "Something went wrong",
    "somethingWentWrongDesc": "An unexpected error occurred. Please try to reload the page.",
    "noItems": "No items found",
    "pageNotFound": "Oops! The page you are looking for does not exist",
    "language": "Language",
    "theme": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "search": "Search",
    "topNavSearch": {
      "placeholder": "Search or ask a question",
      "relevantPassages": "Relevant passages"
    },
    "select": "Select an option",
    "help": "Help",
    "documentHistory": {
      "header": "Audit Trail",
      "events": {
        "version_created": "New version created",
        "version_published": "Version published",
        "version_adopted": "Version adopted",
        "version_archived": "Version archived",
        "document_user_added": "{{firstName}} {{lastName}} added as {{role}}",
        "document_user_removed": "{{firstName}} {{lastName}} removed as {{role}}",
        "workflow_step_user_added": "{{firstName}} {{lastName}} added to step \"{{workflowStepName}}\" with {{permission}} permission",
        "workflow_step_user_removed": "{{firstName}} {{lastName}} removed from step \"{{workflowStepName}}\"",
        "workflow_transition": "Workflow moved from \"{{fromStepName}}\" to \"{{toStepName}}\"",
        "workflow_started": "Workflow started",
        "workflow_completed": "Workflow completed"
      }
    },
    "buttons": {
      "accept": "Accept",
      "addUser": "Add user",
      "archiveProject": "Archive project",
      "cancel": "Cancel",
      "close": "Close",
      "confirm": "Confirm",
      "confirmUpload": "Confirm Upload",
      "create": "Create ",
      "decline": "Decline",
      "delete": "Delete",
      "download": "Download",
      "downloadFile": "Download file",
      "goToTheDashboardPage": "Go to the dashboard page",
      "manage": "Manage",
      "proceed": "Proceed",
      "back": "Back",
      "retry": "Retry",
      "reorder": "Reorder",
      "resetPass": "Reset password",
      "save": "Save changes",
      "saving": "Saving...",
      "uploading": "Uploading...",
      "seeAll": "See all",
      "sentInvitations": "Send Invitations",
      "submit": "Submit",
      "done": "Done",
      "showMore": "Show more",
      "selectAll": "Select all",
      "selectItem": "Select {{name}}",
      "unselectAll": "Unselect all",
      "selectAllFrom": "Select all from",
      "edit": "Edit",
      "finish": "Finish",
      "validate": "Validate",
      "validating": "Validating...",
      "expand": "Expand",
      "collapse": "Collapse",
      "generateDiffSummary": "Generate AI summary",
      "generatingDiffSummary": "Generating...",
      "diffSummaryUpToDate": "No changes to summarize"
    },
    "table": {
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected"
    },
    "create": {
      "document": "Create new document",
      "oneDocument": {
        "title": "One document",
        "description": "Upload a file or create a new document"
      },
      "manyAtOnce": {
        "title": "Many at once",
        "description": "Upload multiple files and configure together"
      }
    },
    "customSelect": {
      "enterOwner": "Enter owner",
      "enterPublisher": "Enter publisher",
      "selectDate": "Select date",
      "selectCategory": "Select category",
      "selectDocument": "Select document",
      "selectOption": "Select option",
      "selectTier": "Select tier"
    },
    "document": {
      "archiveState": "Archive state",
      "category": "Category",
      "categories": "Categories",
      "metadata": "Metadata",
      "owner": "Owner",
      "publisher": "Publisher",
      "referenceNumber": "Reference number",
      "reviewDates": "Review dates",
      "recurringReview": "Recurring review",
      "noRecurringReview": "No recurring review",
      "reviewPeriods": {
        "every3months": "Every 3 months",
        "every6months": "Every 6 months",
        "yearly": "Yearly",
        "every3years": "Every 3 years",
        "every5years": "Every 5 years"
      },
      "reviewFrom": "Review starts",
      "reviewFromDescription": "The workflow will start automatically",
      "reviewTo": "Review ends",
      "reviewToDescription": "The workflow will appear as overdue",
      "reviewDatesMovedToWorkflow": "Scheduled review dates have moved to",
      "goToWorkflowTab": "the Workflow tab.",
      "recurringPeriod": "Period",
      "status": "Status",
      "statuses": {
        "accepted": "Accepted",
        "active": "Active",
        "archived": "Archived",
        "draft": "Draft",
        "opened": "Opened",
        "published": "Published"
      },
      "tag": "Tag",
      "tags": "Tags",
      "tier": "Tier",
      "tiers": "Tiers",
      "noTierLabel": "General document",
      "noTierDescription": "Not part of the governance framework",
      "noLinkingOptions": "There are no other documents available to link.",
      "title": "Title",
      "untitledDocument": "Untitled document",
      "youDontHaveAccess": {
        "title": "You don't have access to this document",
        "subtitle": "Contact a superadmin in your North House platform if you need access"
      },
      "adopted": "Adopted",
      "adoptedAt": "Adopted at",
      "publishedAt": "Published at",
      "emptyDocument": "Empty document",
      "emptyDocumentDescription": "This document is currently empty. Use the 'Open in' button at the top to open it in Office for the web.",
      "emptyDocumentDescription2": "Use the menus in the top right corner to edit document metadata and document roles.",
      "fileSizeLimit": "Your file must be less than 50MB.",
      "archivedVersionWarning": "You are viewing an archived version of this content.",
      "goToLatestVersion": "Go to latest version.",
      "archivedProject": "This document has been archived.",
      "links": "Linked documents",
      "latestPublishedVersion": "Latest published version"
    },
    "user": {
      "name": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "position": "Position",
      "status": "Status",
      "statuses": {
        "active": "Active",
        "deactivated": "Deactivated",
        "deleted": "Deleted",
        "pending": "Pending"
      }
    },
    "download": {
      "documents": "Download documents",
      "description": "Download all published documents or add some of the following filters to download a specific set of documents.",
      "downloading": "Documents downloaded:",
      "error": "An unexpected error occurred while preparing the documents. Please contact support@northhouse.se to get help with your request."
    },
    "filter": {
      "clear": "Clear",
      "title": "Filter"
    },
    "loading": "Loading...",
    "signOut": "Log out",
    "users": "Users",
    "role": "Role",
    "forms": {
      "selectAnOption": "Select an option..."
    },
    "deleteConfirm": "Are you sure you want to proceed?",
    "tags": {
      "manageTagsDescription": "Create, delete, and see which documents use each tag.",
      "usedInXDocuments_one": "Used in {{count}} document",
      "usedInXDocuments_other": "Used in {{count}} documents",
      "notUsed": "Not used",
      "deleteSuccess": "Tag deleted successfully",
      "deleteConfirmTitle": "Delete tag",
      "deleteConfirmDescription": "Are you sure you want to delete this tag? It is used on {{count}} document(s).",
      "noTags": "No tags",
      "noTagsDescription": "Create your first tag to get started.",
      "newTagPlaceholder": "Enter tag name...",
      "createSuccess": "Tag created successfully",
      "tagExists": "A tag with this name already exists"
    },
    "auth": {
      "forgotPassword": "Forgot password",
      "loginTitle": "Login",
      "loginDescription": "Please enter your credentials to log in",
      "email": "Email",
      "password": "Password",
      "ssoDescription": "Press the button to log in with your work account",
      "ssoLogin": "Log in with SSO",
      "emailPasswordLogin": "Log in with email and password",
      "twoFaTitle": "Two-factor authentication",
      "twoFaDescription": "Please enter the code from your authenticator app",
      "twoFaToken": "6-character code",
      "restoreAccount": "Restore account",
      "addSsoTitle": "Single Sign-On",
      "addSsoDescription": "You can replace your current email/password login method with SSO for easier and more secure access.",
      "addSsoButton": "Replace",
      "skipButton": "Skip for now",
      "ssoRequiredToEdit": "You need to sign in with SSO to edit documents",
      "cantEditSpeDraftFile": "You need to have edit rights to edit this draft file"
    },
    "errors": {
      "officeLocalhost": "Office is not available on localhost",
      "noDocument": "Document not found"
    },
    "fileFormat": {
      "word": "Word (.docx)",
      "pdf": "PDF (.pdf)",
      "excel": "Excel (.xlsx)",
      "powerPoint": "PowerPoint (.pptx)"
    },
    "copyright": "North House AB. All Rights Reserved.",
    "translation": {
      "translationStarted": "Translation started",
      "translationDownloaded": "Translation downloaded",
      "translationError": "Translation failed",
      "quotaExceededError": "Translation quota exceeded. Please contact support.",
      "tooManyRequestsError": "Too many translation requests. Please try again later.",
      "isTranslating": "Translating...",
      "downloadTranslatedFile": "Download translated file",
      "selectLanguageDescription": "Select a target language to download a translated version of this document.",
      "selectTargetLanguage": "Language to translate to",
      "selectSourceLanguage": "Current language",
      "selectLanguage": "Select a language...",
      "translationStartedInfo": "Translation has started. You can close this modal."
    },
    "workflows": {
      "search": "Search workflows...",
      "workflow_one": "Workflow",
      "workflow_other": "Workflows",
      "ongoingAndUpcoming": "Ongoing & upcoming",
      "edit": "Edit workflow",
      "stepUserResponses": {
        "approved": "{{firstName}} {{lastName}} approved the step",
        "rejected": "{{firstName}} {{lastName}} rejected the step",
        "pending": "{{firstName}} {{lastName}} has not responded yet",
        "approvedSelf": "You approved the step",
        "rejectedSelf": "You rejected the step",
        "pendingSelf": "You have not responded yet"
      }
    },
    "managers": {
      "title": "Managers"
    },
    "classification": {
      "title": "Classification"
    },
    "unsavedChanges": {
      "title": "Unsaved changes",
      "description": "If you leave this page, your unsaved changes will be lost.",
      "continueEditing": "Continue editing",
      "discardChanges": "Discard changes",
      "documentMetadata": {
        "title": "Discard metadata changes?",
        "description": "If you continue, your unsaved metadata changes will be lost."
      },
      "metadataSheet": {
        "title": "Discard metadata changes?",
        "description": "If you close this panel, your unsaved metadata changes will be lost."
      },
      "documentTitle": {
        "title": "Discard title changes?",
        "description": "If you continue, your unsaved title changes will be lost."
      },
      "workflow": {
        "title": "Discard workflow changes?",
        "description": "If you leave this page, your unsaved workflow changes will be lost."
      }
    },
    "more": "More",
    "commandPalette": {
      "title": "Command Palette",
      "description": "Search for a command to run..."
    },
    "title": "Title",
    "workflow": {
      "respond": {
        "comment": "Leave comment",
        "reject": "Reject",
        "approve": "Approve",
        "leaveAnotherResponse": "Leave another response"
      },
      "stepTitleRequired": "Title is required",
      "stepDescription": "Step description",
      "review": "Review",
      "type": "Type",
      "responseDate": "Response date",
      "responseDateWarning": "The response date for this step is earlier than a previous response date!",
      "description": "Description",
      "assignedUsers": "Assigned Users",
      "assigned": "Assigned:",
      "comment": "Comment",
      "approval": "Approval",
      "reviewRespond": "Review & Respond",
      "noUsersAssigned": "No users assigned",
      "addStep": "Add Step",
      "steps": "Steps",
      "stepsDescription": "Define the sequence of steps and assign users to each step",
      "descriptionDescription": "Describe the purpose of the update to provide context for reviewers, committees and/or approvers",
      "saveChanges": "Save Changes",
      "manageWorkflows": "Manage and track document creation and review processes.",
      "ongoing": "Ongoing",
      "upcoming": "Upcoming",
      "mySteps": "My steps",
      "expandAll": "Expand all",
      "previousStep": "Previous step",
      "completedSteps": "completed steps.",
      "hideSteps": "Hide steps",
      "showSteps": "Show steps",
      "continue": "Continue",
      "cancel": "Cancel",
      "edit": "Edit",
      "stepDueAt": "Due at: {{date}}",
      "delete": "Delete",
      "cannotDeleteOngoing": "Can't delete ongoing or completed step",
      "cannotDeleteWithInstance": "Can't delete steps that have been started",
      "cannotDeleteFirstStep": "Can't delete the first step in the workflow",
      "read": "Read",
      "approved": "Approved",
      "rejected": "Rejected",
      "completed": "Completed",
      "inProgress": "In Progress",
      "progress": "Progress",
      "notStarted": "Not started",
      "removeUser": "Remove user",
      "setAdoptionDate": "Set adoption date",
      "changeAdoptionDate": "Change adoption date",
      "setAdoptionDateDescription": "Select the date when this document was adopted.",
      "missingReviewDates": "Future review dates missing",
      "missingReviewDatesCanManageDescription": "This document is missing future review dates. The document will be published without automatic review reminders.",
      "missingReviewDatesCannotManageDescription": "This document is missing future review dates. Contact the document owner to set review dates.",
      "trackChangesEnabledWarning": "Track Changes is enabled in this document",
      "trackChangesEnabledWarningDescription": "This document has Track Changes enabled, which means changes and comments may be visible to readers. Open the document in Word to disable Track Changes.",
      "unresolvedSuggestionsWarning": "There are unresolved suggestions left in this document",
      "unresolvedSuggestionsWarningDescription": "Accept or reject the suggested edits in Word before publishing so readers only see the final content.",
      "commentsWarning": "This document contains comments",
      "commentsWarningDescription": "Review any remaining comments in Word before publishing so feedback isn't left unresolved.",
      "documentOpenInEditorError": "Document in use",
      "documentOpenInEditorErrorDescription": "Close the document in Office and try again. If someone else is editing it, you can see who in the Office title bar.",
      "publishDocument": "Publish Document",
      "nextReviewPeriod": "Next review period",
      "publishDocumentCanManageDescription": "Publish this document. You can optionally set future review dates to receive automatic reminders.",
      "publishDocumentCannotManageDescription": "Publish this document. Future review dates can only be changed by a document manager.",
      "startDate": "Optional next review start date",
      "endDate": "Optional next review end date",
      "filterDocuments": "Filter Documents",
      "filterDocumentsDescription": "Narrow down which documents to include in your export",
      "selectFields": "Select Fields to Export",
      "selectFieldsDescription": "Choose which document metadata fields to include in your export",
      "exportAsCsv": "Export as CSV",
      "downloadReport": "Download report",
      "exportMetadata": "Export Document Metadata",
      "uploadFile": "Upload File",
      "uploadFileTitle": "Upload File",
      "replaceFileDescription": "Replace the current file for {{versionTitle}}",
      "fileToReplace": "File to be replaced",
      "replaceWarning": "This action will permanently replace the existing file and cannot be undone.",
      "clickToSelectDifferent": "Click to select a different file",
      "clickOrDragToUpload": "Click or drag a file to upload",
      "cannotUploadFileWrongFormat": "Cannot upload \"{{fileName}}\". {{currentFileType}} documents can only be replaced with .{{allowedExtension}} documents.",
      "invalidDocumentId": "Invalid document ID",
      "browseDescription": "Browse and manage your document library.",
      "editWorkflow": "Edit workflow",
      "createdFromTemplate": "Created from template: {{name}}",
      "reading": "Reading",
      "anchoring": "Anchoring",
      "total": "Total",
      "opened": "Opened",
      "notOpened": "Not opened",
      "readerStatusRead": "Read",
      "accepted": "Accepted",
      "reader": "Reader",
      "status": "Status",
      "noReaders": "No readers",
      "published": "Published",
      "archived": "Archived",
      "preview": "Preview",
      "readDocument": "I have read this document",
      "copyLinkToPublishedDocument": "Copy published version link",
      "versionOrder": "Version {{order}}",
      "openInOffice": "Open in {{officeType}}",
      "openInOfficeForWeb": "Open in {{officeType}} for the web",
      "openingInWord": "Opening in Word",
      "openingInWordDescription": "If Word did not open automatically, use the button below.",
      "openInWordFailed": "The document could not be opened in Word.",
      "noPublishedVersion": "This document does not have a published version.",
      "wordFileRequired": "The published version must be a Word document.",
      "documentAlreadyOpenedByYou": "This document is currently opened by you",
      "documentAlreadyOpen": "This document is currently opened by {{name}}",
      "versions": "Versions",
      "addUser": "Add a user...",
      "canEdit": "Can edit",
      "readOnly": "Read only",
      "freeComment": "Commented",
      "started": "Started",
      "approvalDescription": "You have been assigned to approve this document.",
      "writeDescription": "You have been assigned write permission to this document.",
      "readDescription": "You have been assigned read permission to this document.",
      "waitingForApprovals": "Waiting for approvals ({{approvedCount}}/{{totalCount}})",
      "you": "You",
      "proceedWithRejectedResponses": "Proceed with rejected responses?",
      "someParticipantsRejected": "Some participants have rejected this step. Are you sure you want to proceed?",
      "proceedWithoutAllResponses": "Proceed without all responses?",
      "notAllResponded": "Not all participants have responded to this step. Are you sure you want to proceed?",
      "nextStep": "Next step",
      "startWorkflow": "Start workflow",
      "abort": "Abort",
      "cancelWorkflow": "Cancel workflow",
      "cancelWorkflowTitle": "Cancel this workflow?",
      "cancelWorkflowDescription": "This will revert the workflow to its initial state.",
      "created": "Created",
      "startedAt": "Started at",
      "failedToConfirmDocumentReading": "Failed to confirm document reading",
      "diffSummary": {
        "changesComparedTo": "Changes compared to",
        "upToDateTooltip": "A new summary can be generated when changes are made to the document",
        "emptyState": {
          "description": "Generates a concise overview of the differences between Version {{previousVersionNumber}} and Version {{currentVersionNumber}}"
        },
        "noChangesFound": "No changes found between versions. Make changes to the document and try again.",
        "tabTitle": "AI summary"
      },
      "documentMarkedAsRead": "Document marked as read",
      "documentConfirmed": "Document read",
      "documentConfirmedDescription": "You have marked this document as read.",
      "documentReadyForReview": "Document ready for review",
      "pleaseConfirmDocumentRead": "Please confirm that you have read this document.",
      "failedToAddReaders": "Failed to add readers",
      "documentPublishedSuccessfully": "Document published successfully",
      "failedToPublishDocument": "Failed to publish document",
      "allStepsMustHaveName": "All steps must have a name",
      "failedToUpdateWorkflow": "Failed to update workflow",
      "workflowUpdatedSuccessfully": "Workflow updated successfully",
      "failedToUpdateWorkflowStep": "Failed to update workflow step"
    },
    "seasonal": {
      "halloween": "Happy Halloween!",
      "valentines": "Happy Valentine's Day! Treat yourself with some chocolate, you have earned it!",
      "easter": "Happy Easter! Hope the Easter Bunny finds you!",
      "midsommar": "Glad midsommar! Even the frogs and crows are dancing!"
    },
    "sections": {
      "title": "Sections",
      "viewSections": "View Sections",
      "inDocuments": "In Documents",
      "unused": "Unused",
      "preview": "Preview",
      "versionHistoryWithCount": "Version History ({{count}} version)",
      "versionHistoryWithCount_other": "Version History ({{count}} versions)",
      "selectVersionToView": "Select a version to view its content",
      "version": "Version",
      "createdAt": "Created at",
      "createdBy": "Created by",
      "versionsCount": "{{count}} version",
      "versionsCount_other": "{{count}} versions",
      "noSectionSelected": "No section selected",
      "selectSectionDescription": "Select a section from the list to view its versions",
      "noSectionsCreated": "There are no sections created",
      "createSectionsHint": "Use the word add-in to create Sections",
      "usedInDocuments": "Used in documents",
      "noDocuments": "Not used in any documents",
      "latest": "Latest",
      "outdatedVersionsWarning": "Outdated version used",
      "usedInDocumentsCount": "Used in {{count}} document",
      "usedInDocumentsCount_other": "Used in {{count}} documents"
    },
    "support": {
      "pageTitle": "Support",
      "contactSupport": "Contact Support",
      "contactDescription": "Need help? Have a question or found a bug? Reach out to us and we'll get back to you as soon as possible.",
      "emailUs": "Email us at",
      "userGuide": "User Guide",
      "userGuideDescription": "Learn how to use North House or get answers to your questions in our user guide.",
      "viewGuide": "View Guide"
    },
    "addIn": {
      "createWarning": "Section created is visible to all users in your platform",
      "documentLinks": {
        "title": "Document links",
        "searchPlaceholder": "Search documents",
        "searchLabel": "Search documents by title",
        "insertLink": "Insert link",
        "linkInserted": "Link inserted",
        "insertFailed": "The link could not be inserted",
        "noDocuments": "No documents available",
        "noDocumentsDetail": "There are no other published Word documents available.",
        "noSearchResults": "No matching documents",
        "noSearchResultsDetail": "No published Word documents match this search."
      },
      "login": {
        "title": "Log in success",
        "successMessage": "You have successfully signed in to North House.",
        "instructions": "You can now close this window and return to Word.",
        "promptTitle": "North House Add-in",
        "promptMessage": "Please sign in to continue",
        "buttonText": "Sign in",
        "reloadInstructions": "After signing in, close the login window"
      },
      "buttons": {
        "creating": "Creating...",
        "saveNewVersion": "Save new version",
        "saving": "Saving...",
        "applyVersion": "Apply Version",
        "createNewVersion": "Create New Version",
        "removeFromDocument": "Remove from Document",
        "moreActions": "More actions",
        "deleteVersion": "Delete version",
        "deleteSection": "Delete section",
        "previous": "Previous",
        "next": "Next"
      },
      "forms": {
        "createFromSelection": "Create from selection",
        "newSectionNamePlaceholder": "Section name"
      },
      "version": {
        "versionLabel": "Version {{index}} of {{total}}",
        "versions": "{{count}}v",
        "versionPrefix": "v{{number}}"
      },
      "content": {
        "noContentAvailable": "No content available",
        "noSectionsYet": "No sections yet.",
        "sectionsUsedInDocument": "Sections used in this document",
        "availableSections": "Available sections",
        "noSectionsUsedInDocument": "No sections used in this document",
        "noAvailableSections": "No available sections"
      },
      "actions": {
        "createdByPrefix": "Created by"
      },
      "ui": {
        "usedIn": "Used in",
        "newerVersionAvailable": "Newer version is available"
      },
      "messages": {
        "versionDeletedSuccess": "Version deleted successfully",
        "sectionDeletedSuccess": "Section deleted successfully",
        "sectionCreatedSuccess": "Section created successfully",
        "versionSavedSuccess": "New version saved successfully",
        "deleteSectionTitle": "Delete Section",
        "deleteSectionDescription": "This action cannot be undone. This will permanently delete all the versions of section {{sectionName}}.",
        "deleteSectionConfirm": "Delete Section"
      },
      "errors": {
        "deleteSectionFailed": "Failed to delete section",
        "deleteVersionFailed": "Failed to delete version",
        "textSelectionCheckFailed": "Unable to check text selection. Please try again.",
        "pleaseSelectTextFirst": "Please select some text in the document first",
        "logoutMayHaveFailed": "Logout may have failed. Please try again if needed.",
        "sectionInsertFailed": "Failed to insert section",
        "sectionEditFailed": "Failed to edit section",
        "sectionCreateNewVersionFailed": "Failed to create new version",
        "sectionDiscardFailed": "Failed to discard changes",
        "sectionSwitchVersionFailed": "Failed to switch version",
        "sectionSaveFailed": "Failed to save new version",
        "sectionRemoveFailed": "Failed to remove section",
        "sectionSelectionContainsSection": "A section cannot contain another section. Select text outside existing sections.",
        "sectionCreateFailed": "Failed to create section",
        "officeContextNotAvailable": "Something went wrong. Please try again."
      }
    },
    "roles": {
      "superadmin": "Superadmin",
      "coordinator": "Coordinator",
      "contributor": "Contributor",
      "reader": "Reader"
    }
  },
  "legalEntities": {
    "legalEntity": "Legal Entity",
    "legalEntities": "Legal entities",
    "selectEntities": "Select Entities"
  },
  "workflowTemplates": {
    "title": "Workflow Templates",
    "navLabel": "Templates",
    "deleteTemplate": "Delete Template",
    "templateName": "Template Name",
    "templateNamePlaceholder": "Enter template name...",
    "noTemplateSelected": "Select a template from the sidebar to edit it",
    "noTemplates": "No templates yet. Create one to get started.",
    "saveTemplate": "Save Template",
    "saveSuccess": "Template saved successfully",
    "saveError": "Failed to save template",
    "deleteSuccess": "Template deleted successfully",
    "deleteError": "Failed to delete template",
    "templateNameRequired": "Template name is required",
    "newTemplate": "New Template",
    "tabs": {
      "editor": "Editor",
      "applyToDocuments": "Apply to Documents"
    },
    "documentsTable": {
      "title": "Apply to Documents",
      "description": "Select documents to apply this workflow template to. Only documents with a draft version that has not been started are shown.",
      "documentTitle": "Document Title",
      "currentTemplate": "Created from Template",
      "noDocuments": "No eligible documents found.",
      "searchPlaceholder": "Search documents...",
      "none": "None",
      "saveTemplateFirst": "Save the template before applying it to documents."
    },
    "deleteConfirm": {
      "title": "Delete template?",
      "description": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "titleBulk": "Delete {{count}} templates?",
      "descriptionBulk": "Are you sure you want to delete these {{count}} templates? This action cannot be undone."
    },
    "deleteSelected": "Delete Selected ({{count}})",
    "defaultBadge": "Default",
    "cannotDeleteDefault": "The default template cannot be deleted",
    "applyToDocuments": "Apply to Documents ({{count}})",
    "applying": "Applying...",
    "applySuccess": "Template applied to documents",
    "applyError": "Failed to apply template",
    "applyConfirm": {
      "title": "Override existing templates?",
      "description": "{{count}} of the selected documents already have a template applied. Applying this template will replace their current workflow.",
      "confirm": "Apply Anyway"
    },
    "applyOnWorkflow": {
      "selectPlaceholder": "Apply a template",
      "apply": "Apply",
      "success": "Template applied successfully",
      "error": "Failed to apply template",
      "unsavedChangesTitle": "Discard unsaved changes?",
      "unsavedChangesDescription": "You have unsaved workflow changes that will be lost when applying this template.",
      "unsavedChangesConfirm": "Discard & Apply"
    },
    "applyDatesDialog": {
      "description": "Set review dates and step due dates for each document before applying the template.",
      "documentTitle": "Document Title",
      "apply": "Apply Template",
      "confirmDates": "Confirm Dates",
      "confirmDescription": "Review the dates below and confirm to apply the template.",
      "errorAfterPrevious": "Must be same or after previous date",
      "errorNotInPast": "Must not be in the past"
    }
  }
}
